import { FieldError } from 'react-hook-form';
import { InputHTMLAttributes, useState } from 'react';
import { EyeSlashIcon } from '@heroicons/react/24/outline';
import { EyeIcon } from '@heroicons/react/24/outline';
import { cn } from '@/utils/utils';

export interface IInput extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  isTouched?: boolean;
  error?: FieldError | undefined;
}

export const PasswordInput = ({ label, error, isTouched, ...props }: IInput) => {
  const [showPassword, setShowPassword] = useState(false);
  return (
    <div className='flex flex-col gap-[6px]'>
      <label className='text-xs font-[MuseoSansCyrl]'>{label}</label>
      <div className='relative w-full'>
        <input
          type={showPassword ? 'text' : 'password'}
          className={cn(
            'w-full rounded-[8px] border outline-none px-[10px] py-[8px] font-[MuseoSansCyrl] text-[14px]',
            error ? 'border-red-500' : 'border-content-secondary'
          )}
          {...props}
        />
        <button
          type='button'
          onClick={() => setShowPassword((prevState) => !prevState)}
          className='absolute right-3 top-1/2 -translate-y-1/2 cursor-pointer'
        >
          {showPassword ? (
            <EyeIcon className='h-6 w-6 text-gray-500' />
          ) : (
            <EyeSlashIcon className='h-6 w-6 text-gray-500' />
          )}
        </button>
      </div>
      {isTouched && error && <div className='text-red text-[14px] font-[MuseoSansCyrl]'>{error.message}</div>}
    </div>
  );
};
